const menu_en={
    "button":{
        "plans":"Plans",
        "contact":"Get in touch",
        "learnMore":"Learn More"
    }
} 
export default menu_en
